export const environment = {
  name: 'qual-hemo',

  production: true,
  localTranslations: false,

  apiDomain: 'qual-hemo-connect.bizzdev.net',
  apiUrl: 'https://qual-hemo-connect.bizzdev.net/api/',
  identityApiUrl: 'https://qual-hemo-connect.bizzdev.net/identity/',

  tokenKey: 'token',
  tokenExpKey: 'token-exp',
  rfTokenKey: 'rf-token',

  appName: "Qual Hemo Connect",

  version: require('../../package.json').version,
  build: require('../../package.json').build
};
